// extracted by mini-css-extract-plugin
export default {"backButtonContainer":"BackButton_backButtonContainer__x3NwY","backButton":"BackButton_backButton__29MYY"};